import React from 'react';
/**
 * data Columns for grid and mobile view
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Data Columns Array
 */
export const DataColumns = ({
  editScreen,
  GridFlag,
  BooleanValuesFilterCell,
}) => {
  const dataColumns = [
    {
      field: 'LookupId',
      title: 'Lookup Id',
      editable: false,
      show: false,
      width: '250px',
      width: '250px',
      minResizableWidth: 150,
      filterable: false,
      excludeFromFilter: true,
    },
    {
      field: 'Type',
      title: 'Type',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 150,
      filterable: false,
      excludeFromFilter: true,
      cell: (props) => (
        <td
          className='edit-link'
          onClick={() => {
            editScreen(props.dataItem);
          }}
        >
          {props.dataItem.Type}
        </td>
      ),
    },
    {
      field: 'Active',
      title: 'Active',
      editable: false,
      show: true,
      filterable: false,
      width: '200px',
      minResizableWidth: 50,
      cell: GridFlag,
      filterCell: BooleanValuesFilterCell,
    },
  ];

  return dataColumns;
};
export default DataColumns;
